import request from '../../utils/request'
//srm编辑新增自定义区域
//查询
export function getEditShowByOrgCode() {
  return request({
    url: '/signing/eshop/srm/supplierBusinessArea/custom',
    method: 'get',
  })
}

//保存配置
export function editAreaSaveAndAudit(data) {
  return request({
    url: '/signing/eshop/srm/supplierBusinessArea/saveAndAudit',
    method: 'post',
    data
  })
}

//查看自定义区域列表
export function customList() {
  return request({
    url: '/signing/custom/list',
    method: 'get',
  })
}

//保存自定义区域(递交审核用)
export function customSave(data) {
  return request({
    url: '/signing/custom/save',
    method: 'post',
    data
  })
}

//所有区域列表(包含自定义区域)
export function resourceCustomList() {
  return request({
    url: '/resource/custom/list',
    method: 'get',
  })
}

//新增或修改自定义区域
export function resourceCustomSave(data) {
  return request({
    url: '/resource/custom/save',
    method: 'post',
    data
  })
}

//审核自定义区域
export function audit(data) {
  return request({
    url: '/signing/custom/audit',
    method: 'post',
    data
  })
}








//other
// 获取TAS And SRM 审核记录列表（已提交审核）
export function getOneSettledList() {
  return request({
    url: '/signing/eshop/base/audit/queryCurrOrgAuditStatus',
    method: 'get',
  })
}

// /signing/eshop/base/operatorRecord/querySigningOperator

//入驻操作记录
export function querySigningOperator(params) {
  return request({
    url: '/signing/eshop/base/operatorRecord/querySigningOperator',
    method: 'get',
    params
  })
}

//step0 注册页

//验证码
export function verificationCode(data) {
  return request({
    url: '/auth/account/verificationCode',
    method: 'post',
    data
  })
}
// 查询注册手机号是否存在
export function exsitPhone(data){
  return request({
    url:'/auth/account/queryAccountIsExists',
    method:'get',
    params:data
  })
}

//注册btn
export function registerSupplier(data) {
  return request({
    url: '/auth/account/regist',
    method: 'post',
    data
  })
}




//step1 基础信息页面

//保存基础信息
export function saveSupplierBaseInfo(data) {
  return request({
    url: '/signing/eshop/srm/supplier/add',
    method: 'post',
    data
})
}
//助旅通信息同步
export function getSupplierInfoByCreditCodeAndPhone(data){
  return request({
    url:'/external/Zltlm/getSupplierInfoByCreditCodeAndPhone',
    method: 'post',
    data
  })
}

//获取基础信息
export function getSupplierBaseInfo(query) {
  return request({ 
    url: '/signing/eshop/srm/supplier/query',
    method: 'get',
    params:query
})
}

// 基础信息品牌名最多可以添加几个
export function getBrandNums() {
  return request({ 
    url: '/signing/eshop/srm/qualification/getBrandNums',
    method: 'get',
  })
}


// dasGetInfo
export function dasGetInfo(query) {
  return request({
    url: '/signing/eshop/srm/supplier/audit',
    method: 'get',
    params:query
})
}

//修改基础信息
export function updateSupplierBaseInfo(data,status) {
  //0 审核前 ，// 审核后
  console.log(status);
  // let url = status==0?'/signing/eshop/srm/supplier/update':status==1?'/signing/eshop/srm/supplier/edit':''
  let url = '/signing/eshop/srm/supplier/update'
  return request({
      url: url,
      method: 'post',
      data
  })
}

// 是否需要审核
export function isNeedAuditOrgInfo() {
  return request({
    url: '/signing/eshop/srm/supplier/isNeedAuditOrgInfo',
    method: 'post',
})
}





//step2 资质  // isEntry:True Nolist

//获取资质列表
export function getQualificationList(query) {
  return request({
    url: '/signing/eshop/srm/qualification/list',
    method: 'get',
    params: query
  })
}

//获取资质列表长度

export function queryBrandCount(query) {
  return request({
    url: '/signing/eshop/srm/supplierbrand/queryBrandCount',
    method: 'get',
    params: query
  })
}
// 保存资质信息
export function saveQualification(data) {
  return request({
    url: '/signing/eshop/srm/qualification/saveQualificationInfo',
    method: 'post',
    data
  })
}

//保存（草稿箱）

//删除某一条资质
export function deleteQualification(qualificationCode) {
  return request({
    url: `/signing/eshop/srm/qualification/delete`,
    method: 'get',
    params:{
      qualificationCode:qualificationCode
    }
  })
}

//修改资质信息（主资质依然不可修改基本信息）
// 获取当前编号资质详情
export function getQualificationDetail(data) {
  return request({
    url: `/signing/eshop/srm/qualification/infoByQualificationCode`,
    method: 'post',
    data:data
  })
}
//保存修改
export function updateQualification(data) {
  return request({
    url: '/signing/eshop/srm/qualification/updateQualificationInfo',
    method: 'post',
    data
  })
}

//查询操作日志
export function getQualificationLog(qualificationCode) {
  return request({
    url: `/signing/eshop/srm/qualification/queryLog/${qualificationCode}`,
    method: 'get',
  })
}




//step3 主营业务范围及区域

//获取经营范围
export function getSupplierBusinessArea(data) {
  return request({
    url: '/signing/eshop/srm/supplierBusinessArea/showByOrgCode',//'/signing/eshop/srm/supplierBusinessArea/show'
    method: 'get',
    params:data
  })
}
//获取经营范围by orgCode
export function getSupplierBusinessAreaByOrgCode(data) {
  return request({
    url: '/signing/eshop/srm/supplierBusinessArea/showByOrgCode',
    method: 'get',
    params:data
  })
}
//保存经营范围
export function saveSupplierBusinessArea(data) {
  return request({
    url: '/signing/eshop/srm/supplierBusinessArea/save',
    method: 'post',
    data
  })
}

//保存并审核 saveAndAudit
export function saveAndAudit(data) {
  return request({
    url: '/signing/eshop/srm/supplierBusinessArea/saveAndAudit',
    method: 'post',
    data
  })
}



//step4:投放区域

//获取列表  （剩余修改次数）
export function supplierLaunchAreaList(data){
  return request({
    // url: '/signing/supplierLaunchArea/list',
    // method: 'get',
    url:'/signing/supplierLaunchArea/queryAllSupplierLaunchArea',
    method:'post',
    data
    
  })
}
//获取当前经营范围区域用于投放 getAreaListByToken
export function getAreaListByToken(){
  return request({
    url: '/signing/eshop/srm/supplierBusinessArea/getLaunchAreaListByToken',
    method: 'get',
  })
}

//新增投放区域设置
export function addLaunchArea(data) {
  return request({
    // url: '/signing/supplierLaunchArea/insert',
    url:'/signing/supplierLaunchArea/batchAdd',
    method: 'post',
    data
  })
}

//根据id查找该条详情--修改
export function getLaunchAreaDetail(id){
  return request({
    // url: `/signing/supplierLaunchArea/info/${id}`,
    url:'/signing/supplierLaunchArea/querySingleSupplierLaunchArea',
    method: 'get',
    params:{
      id:id
    }
    //数据类型
  })
}

//更新该id详情--修改
export function updateLaunchAreaDetail(id,data) {
  // return request({
  //   url: `/signing/supplierLaunchArea/update/${id}`,
  //   method: 'put',
  //   data
  // })

  return request({
    url: `/signing/supplierLaunchArea/saveSingleSupplierLaunchArea`,
    method: 'post',
    data
  })

}

//删除某一条投放地区数据
export function deleteLaunachAreaDetail(id) {
  // return request({
  //   url: `/signing/supplierLaunchArea/delete/${id}`,
  //   method: 'delete',
  // })
  return request({
    url: `/signing/supplierLaunchArea/deleteSupplierLaunchAreaById`,
    method: 'get',
    params:{
      id:id
    }
  })
}










// end

// //同步助旅通信息按钮
// export function loadZLTInfo(data) {
//   return request({
//     url: '',
//     method: 'post',
//     data
//   })
// }









//获取资质的经营范围及其区域
export function getAreaList(data) {
  return request({
    url: '',
    method: 'post',
    data
  })
}

//范围选择中获取当前可用资质列表
// export function getAvilableQualificationList(query) {
//   return request({
//     // url: '/signing/eshop/srm/qualification/list',
//     method: 'get',
//     params: query
//   })
// }

//保存当前范围勾选区域
export function saveAreas(data) {
  return request({
    url: '',
    method: 'post',
    data
  })
}





// WEBPACK FOOTER //
// ./src/SRM/api/entry.js